import {customDocumentEvent} from "../../../webpack/modules/events";
import {previewOption} from "../../../webpack/modules-optimized/product";

customDocumentEvent('productModelChanged', function(event) {
    let option = event.detail.option;
    let previewElement = event.detail.previewElement;

    previewOption(option, previewElement);
});